var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganisations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 48 48",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    transform: "translate(-79.727 -73.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.8,105.8c1.7-5.2,1.1-10.8-1.5-15.6c-0.4-0.7-1.3-0.9-1.9-0.5c-0.6,0.4-0.9,1.2-0.5,1.8c2.1,3.9,2.6,8.4,1.5,12.6 c-1.2-0.6-2.6-0.9-3.9-0.9h-0.1c-5.1,0-9.3,4.1-9.3,9.2c0,5.2,4.1,9.4,9.3,9.4c0,0,0,0,0,0h0.1c5.1,0,9.3-4.1,9.3-9.3 C127.7,110.1,126.7,107.6,124.8,105.8L124.8,105.8z M124.9,112.5c0,3.6-2.9,6.5-6.4,6.5c-3.6,0-6.5-2.9-6.5-6.4 c0-3.6,2.9-6.5,6.4-6.5c0,0,0,0,0,0C122,106.1,124.9,108.9,124.9,112.5L124.9,112.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6,90.2L89.6,90.2c0.6,0.4,1.5,0.3,1.9-0.3c2.8-3.9,7-6.5,11.8-7.1c0,0.1,0,0.3,0,0.4c-0.1,5.2,4.1,9.4,9.3,9.5h0.2 c5.1,0,9.3-4.1,9.4-9.2c0.1-5.2-4.1-9.4-9.2-9.5c0,0,0,0,0,0h-0.2c-3.9,0-7.4,2.4-8.8,6c-5.9,0.5-11.3,3.5-14.7,8.4 C88.9,88.9,89,89.7,89.6,90.2z M112.6,76.7c3.6,0,6.4,2.9,6.4,6.5c0,3.6-2.9,6.4-6.5,6.4c-3.5,0-6.4-2.9-6.4-6.4 C106.1,79.6,109,76.7,112.6,76.7L112.6,76.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_198"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.6,117h-0.2l0,0c-0.2,0-0.5,0-0.8,0c-5.6,0-10.9-2.8-14.1-7.4c4.9-1.4,7.8-6.5,6.4-11.5c-1.4-4.9-6.5-7.8-11.5-6.4 c-2.1,0.6-4,2-5.2,3.8c-1.4,2.1-1.8,4.6-1.3,7c0.9,4.1,4.3,7.1,8.5,7.3c3.6,6.1,10.2,9.8,17.3,9.8c0.4,0,0.7,0,1.1,0 c0.8,0,1.4-0.7,1.3-1.4S107.4,116.9,106.6,117C106.6,116.9,106.6,116.9,106.6,117L106.6,117z M95.5,100.8c0,3.6-2.9,6.5-6.4,6.5 c-3.6,0-6.5-2.9-6.5-6.4c0-3.6,2.9-6.5,6.4-6.5c0,0,0,0,0,0C92.5,94.3,95.4,97.2,95.5,100.8L95.5,100.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisations);
export default __webpack_public_path__ + "static/media/organisations.d05c13d2574c25a9da4684329446b224.svg";
export { ForwardRef as ReactComponent };